var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FlagService } from './../modules/features/flag.service';
var ContentLoggedOutComponent = (function () {
    function ContentLoggedOutComponent(titleService, flag) {
        this.titleService = titleService;
        this.titleService.setTitle("Client Experience");
        this.isAuth0FlagActivate = flag.isAuth0LoginActive();
        document.getElementsByTagName('body')[0].className = 'fixed-sidebar connexion loggedout';
    }
    ContentLoggedOutComponent = __decorate([
        Component({
            selector: 'cx-content-loggedout',
            templateUrl: './common/content_loggedout.component.html',
            encapsulation: ViewEncapsulation.None
        }),
        __metadata("design:paramtypes", [Title, FlagService])
    ], ContentLoggedOutComponent);
    return ContentLoggedOutComponent;
}());
export { ContentLoggedOutComponent };
//# sourceMappingURL=content-loggedout.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/components/content-loggedout.component.js
// module id = 262
// module chunks = 0